import { useModalAction } from '@components/common/modal/modal.context'
import Button from '@components/ui/button'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { SubmitHandler, useForm } from 'react-hook-form'
import { Dispatch, FC, SetStateAction, useContext } from 'react'
import pdpQuestionAnswersService from '@services/pdp-questionanswer-service'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
import TextArea from '@components/ui/form/text-area'
import { toast } from 'react-toastify'
import { useMutation } from 'react-query'
interface AddAnswerFormProps {
  setAddAnswer: Dispatch<SetStateAction<any[]>>
  question_id: string
}
const AddAnswerForm: FC<AddAnswerFormProps> = ({
  setAddAnswer,
  question_id,
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { user } = useContext(UserContext) as IUser

  const { closeModal, openModal } = useModalAction()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>()

  function closePopup() {
    closeModal()
  }

  const { mutate, isLoading, isError, isSuccess, error } = useMutation(
    ({ message }: { message: string }) => {
      return pdpQuestionAnswersService.addAnswer({
        data: {
          question_id,
          customer_name: user?.firstname,
          customer_id: user?.id,
          position: '3',
          answer: message,
        },
      })
    },
    {
      onSuccess: (response: any) => {
        if (response.status) {
          toast.success(response?.massage, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success',
          })
          setAddAnswer([])
        } else
          toast.error(response?.massage, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error',
          })
      },
      onError: (err: Error) => {
        toast.error(`Error submitting question: ${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error',
        })
      },
    },
  )
  const AddAnswer: SubmitHandler<{ message: string }> = (data) => {
    mutate(data)
  }

  return (
    <form onSubmit={handleSubmit(AddAnswer)} className="w-full mt-3">
      <textarea
        required
        maxLength={350}
        {...register('message')}
        className="w-full h-32 border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="Write your message here..."
      />

      <div className="flex  space-x-4 mt-4">
        <button
          onClick={() => setAddAnswer([])}
          className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-6 py-2 bg-brand text-white rounded-md "
        >
          Submit
        </button>
      </div>
    </form>
  )
}

export default AddAnswerForm
